<template>
  <BranchForm
    buttonTitle="Сохранить"
    @saveBranch="handleSave"
    @saveBankAccount="handleBankSave"
  />
</template>

<script>
import BranchForm from './components/BranchForm.vue'

export default {
  components: {
    BranchForm
  },
  methods: {
    handleSave(data) {
      this.$km_track('Profile', 'Save', 'Data', data)
    },
    handleBankSave() {
      this.$km_track('Profile', 'Save', 'BankAccount')
    }
  }
}
</script>

<style lang="scss"></style>
